import { FeedingEndpoints } from '@scaleaq/sitecontrol-lib';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import {
  type SetIntensityCommand,
  type StartBlowerCommand,
  type StartFeedingCommand,
  type StopFeedingCommand,
} from '@/dataAccess/rest';
import { useAuthApiPost } from '@/dataAccess/rest/apiHooks';

export const useStartFeeding = (identifier?: string) =>
  useAuthApiPost<StartFeedingCommand>({
    baseApiRoute: API_NAMES.feedingApi,
    cacheKeys: [CACHE_KEYS.startFeeding],
    route: FeedingEndpoints.startFeedingEndpoint,
    resolveRoute: ({ penInventoryId }) =>
      buildFeedingRoute(FeedingEndpoints.startFeedingEndpoint, penInventoryId),
    sendEmptyBody: true,
    identifier: identifier ?? 'startFeeding',
    returnJsonResult: false,
  });

export const useStopFeeding = (identifier?: string) =>
  useAuthApiPost<StopFeedingCommand>({
    baseApiRoute: API_NAMES.feedingApi,
    cacheKeys: [CACHE_KEYS.startFeeding],
    route: FeedingEndpoints.stopFeedingEndpoint,
    resolveRoute: ({ penInventoryId }) =>
      buildFeedingRoute(FeedingEndpoints.stopFeedingEndpoint, penInventoryId),
    sendEmptyBody: true,
    identifier: identifier ?? 'stopFeeding',
    returnJsonResult: false,
  });

/** The blower is stopped through `useStopFeeding`: the feeding API has no separate stop route. */
export const useStartBlower = (identifier?: string) =>
  useAuthApiPost<StartBlowerCommand>({
    baseApiRoute: API_NAMES.feedingApi,
    cacheKeys: [CACHE_KEYS.startFeeding],
    route: FeedingEndpoints.startBlowerEndpoint,
    resolveRoute: ({ penInventoryId }) =>
      buildFeedingRoute(FeedingEndpoints.startBlowerEndpoint, penInventoryId),
    sendEmptyBody: true,
    identifier: identifier ?? 'startBlower',
    returnJsonResult: false,
  });

export const useSetFeedIntensity = (identifier?: string) =>
  useAuthApiPost<SetIntensityCommand>({
    baseApiRoute: API_NAMES.feedingApi,
    cacheKeys: [],
    route: FeedingEndpoints.setIntensityEndpoint,
    resolveRoute: ({ penInventoryId, intensity }) =>
      buildFeedingRoute(FeedingEndpoints.setIntensityEndpoint, penInventoryId).replace(
        '{intensity}',
        intensity != null ? String(intensity) : ''
      ),
    sendEmptyBody: true,
    identifier: identifier ?? 'setFeedIntensity',
    returnJsonResult: false,
  });

const buildFeedingRoute = (endpoint: string, penInventoryId?: string): string =>
  endpoint.replace('{inventoryId}', penInventoryId ?? '');
